module.exports = __webpack_public_path__ + "img/header-back.d752f6be.jpg";